import Vue from 'vue'

import Hotjar from 'vue-hotjar'
// import VueGtm from 'vue-gtm';
// import VueGtag from "vue-gtag";
// import * as VueGoogleMaps from "vue2-google-maps";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'simplebar/dist/simplebar.min.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown, faChevronUp, faCheck, faTimes  } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import router from './router'
import store from './store'
import App from './App.vue'


library.add(faChevronDown, faChevronUp, faCheck, faTimes)

Vue.component('font-awesome-icon', FontAwesomeIcon)

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "",
//     libraries: "places", // necessary for places input
//     region: "uk,en"
//   }
// });


// Vue.use(VueGtag, {
//   config: { id: "G-XTTD0Y35FQ" }
// }, router);

// Vue.use(VueGtm, {
//   id: 'GTM-TQ236WM', // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
//   // queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
//   //   gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
//   //   gtm_preview:'env-4',
//   //   gtm_cookies_win:'x'
//   // },
//   defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
//   enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//   debug: true, // Whether or not display console logs debugs (optional)
//   loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//   // vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//   // ignoredViews: ['homepage'], // Don't trigger events for specified router names (case insensitive) (optional)
//   trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
// });

Vue.use (Hotjar, {
  id: '5288042', // Hotjar Site ID
  isProduction: true,
  snippetVersion: 6
})

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
